import Odometer from 'odometer';
import {isInViewport} from "../helpers";

const stats = document.querySelectorAll('.number.odometer');

[].forEach.call(stats, (el, index) => {

    const checkElementAndAnimate = () => {
        if(isInViewport(el)) {
            const od = new Odometer({
                el,
//        value: "00",
                // Any option (other than auto and selector) can be passed in here
                format: '(,ddd)',
                theme: 'minimal',
            });

            setTimeout(() => od.update(el.getAttribute('data-odometer-value')), index * 0)
        }
    };

    checkElementAndAnimate();
    window.addEventListener('scroll', checkElementAndAnimate);
} );

// or
//el.innerHTML = 555
